module.exports = require("./objectWithoutProperties.js");


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/helpers/object-without-properties.js
// module id = 355
// module chunks = 0